import component from './index';

import less from '!raw-loader!./index.less';
import templateStr from '!raw-loader!./index';

export default {
  component,
  templateStr,
  less,
  dataSource: {
    wrapper: {
      className: 'home-page-wrapper feature25',
      playScale: 0.3,
      always: false,
    },
    page: {
      className: 'home-page feature25-page',
    },
    bg: {
      className: 'feature25-bg',
      children: 'https://imm.86links.com/assets/landing/feature/feature25.png',
    },
    content: {
      className: 'feature25-content',
      box: {
        className: 'feature25-content-box',
        children: [
          {
            name: '大标题',
            className: 'feature25-content-box-title',
            children: '大标题',
          },
          {
            name: '小标题',
            className: 'feature25-content-box-hint',
            children: '小标题',
          },
          {
            name: '内容',
            className: 'feature25-content-box-text',
            children:
              '聚集"汽车+"新经济、"赛事+"新经济、智能制造、文化创意、汽车贸易博览、大健康等高新技术、创新型企业500余家。聚集"汽车+"新经济、"赛事+"新经济、智能制造、文化创意、汽车贸易博览、大健康等高新技术、创新型企业500余家。聚集"汽车+"新经济、"赛事+"新经济、智能制造、文化创意、汽车贸易博览、大健康等高新技术、创新型企业500余家。聚集"汽车+"新经济、"赛事+"新经济、智能制造、文化创意、汽车贸易博览、大健康等高新技术、创新型企业500余家。聚集"汽车+"新经济、"赛事+"新经济、智能制造、文化创意、汽车贸易博览、大健康等高新技术、创新型企业500余家。聚集"汽车+"新经济、"赛事+"新经济、智能制造、文化创意、汽车贸易博览、大健康等高新技术、创新型企业500余家。聚集"汽车+"新经济、"赛事+"新经济、智能制造、文化创意、汽车贸易博览、大健康等高新技术、创新型企业500余家。聚集"汽车+"新经济、"赛事+"新经济、智能制造、文化创意、汽车贸易博览、大健康等高新技术、创新型企业500余家。聚集"汽车+"新经济、"赛事+"新经济、智能制造、文化创意、汽车贸易博览、大健康等高新技术、创新型企业500余家。聚集"汽车+"新经济、"赛事+"新经济、智能制造、文化创意、汽车贸易博览、大健康等高新技术、创新型企业500余家。聚集"汽车+"新经济、"赛事+"新经济、智能制造、文化创意、汽车贸易博览、大健康等高新技术、创新型企业500余家。聚集"汽车+"新经济、"赛事+"新经济、智能制造、文化创意、汽车贸易博览、大健康等高新技术、创新型企业500余家。聚集"汽车+"新经济、"赛事+"新经济、智能制造、文化创意、汽车贸易博览、大健康等高新技术、创新型企业500余家。聚集"汽车+"新经济、"赛事+"新经济、智能制造、文化创意、汽车贸易博览、大健康等高新技术、创新型企业500余家。聚集"汽车+"新经济、"赛事+"新经济、智能制造、文化创意、汽车贸易博览、大健康等高新技术、创新型企业500余家。聚集"汽车+"新经济、"赛事+"新经济、智能制造、文化创意、汽车贸易博览、大健康等高新技术、创新型企业500余家。聚集"汽车+"新经济、"赛事+"新经济、智能制造、文化创意、汽车贸易博览、大健康等高新技术、创新型企业500余家。聚集"汽车+"新经济、"赛事+"新经济、智能制造、文化创意、汽车贸易博览、大健康等高新技术、创新型企业500余家。聚集"汽车+"新经济、"赛事+"新经济、智能制造、文化创意、汽车贸易博览、大健康等高新技术、创新型企业500余家。聚集"汽车+"新经济、"赛事+"新经济、智能制造、文化创意、汽车贸易博览、大健康等高新技术、创新型企业500余家。',
          },
        ],
      },
    },
  },
};
